<template>
  <div class="event-card">
    <span>le {{ displayDate(event.activity_date) }} pendant {{ event.duration }} heures</span>
    <h4>{{ event.name }}</h4>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'EventCard',
  props: {
    event: Object,
  },
  methods : {
    displayDate(eventDate) {
      return dayjs(eventDate).format("DD.MM.YYYY")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.event-card {
  padding: 20px;
  width: 250px;
  cursor: pointer;
  border: 1px solid #39495c;
  margin-bottom: 18px;
}
.event-card:hover {
  transform: scale(1.01);
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2);
}
</style>
